<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Achats",
          icon: "bi bi-clipboard-check-fill",
          route: "purchases-index",
        },
        {
          label: "À valider",
          icon: "bi bi-hourglass-split",
          route: "purchases-tovalidate-index",
        },
        {
          label: "Remarquées",
          icon: "bi bi-info-circle-fill",
          route: "purchases-noticed-index",
        },
        {
          label: "Rapport fournisseur",
          icon: "bi bi-person-lines-fill",
          route: "purchases-supplier-report",
        },
        {
          label: "Nouvel achat",
          icon: "bi bi-bag-plus-fill",
          route: "purchases-create",
        },
        {
          label: "Recherche articles",
          icon: "bi bi-search",
          route: "purchases-items-search",
        },
      ],
    };
  },
};
</script>
